export const conditionally = <Props, Result>(options: {
  if: (props: Props) => any
  then: (props: Props) => Result | Result
  else: (props: Props) => Result | Result
}) => (props: Props) => {
  return options.if(props) ? options.then(props) : options.else(props)
}

export function getNestedValue(
  obj: any,
  path: Array<string | number>,
  fallback?: any
): any {
  const last = path.length - 1

  if (last < 0) {
    return obj === undefined ? fallback : obj
  }

  for (let i = 0; i < last; i++) {
    if (obj == null) {
      return fallback
    }
    obj = obj[path[i]]
  }

  if (obj == null) {
    return fallback
  }

  return obj[path[last]] === undefined ? fallback : obj[path[last]]
}

export const hasNestedProperties = (
  object: any,
  level: string,
  ...levels: string[]
): boolean => {
  if (object === undefined) {
    return false
  }
  if (levels.length === 0 && object.hasOwnProperty(level)) {
    return true
  }
  const nextLevel = levels.shift()
  if (nextLevel) {
    return hasNestedProperties(object[level], nextLevel, ...levels)
  }
  return false
}

export const uid = (() => {
  const s4 = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }

  return () => {
    return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`
  }
})()

export function keys<O>(o: O) {
  return Object.keys(o) as Array<keyof O>
}
